// Where signing in comes back to: this page, query string included (e.g. an event invite's ?i=, which
// invite-only events need to accept the registration). Encode it before passing it as ?next=.
export const signInReturnUrl = () => window.location.pathname + window.location.search;

export default signInReturnUrl;
